import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { SchoolProvider, useSchool } from './context/SchoolContext';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Dashboard from './pages/Dashboard';
import Leads from './pages/Leads';
import Customers from './pages/Customers';
import Scheduling from './pages/Scheduling';
import Financials from './pages/Financials';
import KPIPerformance from './pages/KPIPerformance';
import Reports from './pages/Reports';
import Notifications from './pages/Notifications';
import PackagesPromos from './pages/PackagesPromos';
import BranchManager from './pages/BranchManager';
import StaffManager from './pages/StaffManager';
import VehicleManager from './pages/VehicleManager';
import KPIConfiguration from './pages/KPIConfiguration';
import UserManager from './pages/UserManager';
import Settings from './pages/Settings';
import AppLoader from './components/AppLoader';
import './App.css';

const AppContent = ({ isSidebarOpen, setIsSidebarOpen }) => {
  const { loading } = useSchool();
  return (
    <>
      <AppLoader appName="Business Owner Portal" loading={loading} />
      <div className={`app-container ${isSidebarOpen ? 'sidebar-open' : ''}`}>
        <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
        <div className="main-content">
          <Header title="Safe Driver Owner" onMenuClick={() => setIsSidebarOpen(!isSidebarOpen)} />
          <div className="page-content">
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/leads" element={<Leads />} />
              <Route path="/customers" element={<Customers />} />
              <Route path="/scheduling" element={<Scheduling />} />
              <Route path="/packages" element={<PackagesPromos />} />
              <Route path="/branches" element={<BranchManager />} />
              <Route path="/staff" element={<StaffManager />} />
              <Route path="/instructors" element={<StaffManager isInstructorMode={true} />} />
              <Route path="/vehicles" element={<VehicleManager />} />
              <Route path="/financials" element={<Financials />} />
              <Route path="/kpis" element={<KPIConfiguration />} />
              <Route path="/kpi-performance" element={<KPIPerformance />} />
              <Route path="/users" element={<UserManager />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/notifications" element={<Notifications />} />
              <Route path="/settings" element={<Settings />} />
            </Routes>
          </div>
        </div>
      </div>
    </>
  );
};

function App() {
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);

  return (
    <SchoolProvider>
      <Router>
        <AppContent isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} />
      </Router>
    </SchoolProvider>
  );
}

export default App;
